import { ComponentProps } from 'react';
import clsx from 'clsx';

import { OpButton } from '../OpButton/OpButton';

import './OpTextButton.scss';

/**
 * OpTextButton is a styled button component that appears as a text link.
 * It's built on OpButton with type="link" for consistent link-style buttons.
 * 
 * Use this component for actions that should look like links but have button semantics.
 * Useful for inline actions, secondary actions, or navigation that needs button behavior.
 * 
 * @example
 * <OpTextButton onClick={handleClick}>Click here</OpTextButton>
 * 
 */
export const OpTextButton = ({
  className,
  children,
  ...buttonProps
}: Omit<ComponentProps<typeof OpButton>, 'type'>) => {
  return (
    <OpButton
      type="link"
      className={clsx('op-text-button', className)}
      {...buttonProps}
    >
      {children}
    </OpButton>
  );
};
